<div class="blu-container OR-container">
  <div class="page-namer row1">
    <mat-form-field [floatLabel]="'never'">
      <mat-label>{{ webpages.length > 0 ? 'Select Page' : 'Create Page' }}</mat-label>
      <mat-select #pn (selectionChange)="changePage(pn.value)" [disabled]="webpages?.length === 0">
        <mat-option class="studio_list" *ngFor="let page of webpages" [value]="page._id">
          {{page.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <!-- <mat-form-field>
      <mat-label>Select an option</mat-label>
      <mat-select disableRipple>
        <mat-option value="1">Option 1</mat-option>
        <mat-option value="2">Option 2</mat-option>
        <mat-option value="3">Option 3</mat-option>
      </mat-select>
    </mat-form-field> -->
    <div class="ct_mat">
      <div id="newPageBtn" class="object-icon-newelem newPage" (click)="addnewPageDiag()">
        <span uk-tooltip="Add New" class="add-icon" uk-icon="plus"></span>
      </div>
      <ng-container *featureVisible="'API_TESTING'">
        <div id="importApiBtn" class="object-icon-newelem importApi" [featureActionState]="'API_TESTING'"
          (click)="openImportApiObjects()">
          <span uk-tooltip="Import API Objects" class="add-icon" uk-icon="cloud-upload"></span>
        </div>
      </ng-container>
      <div id="editPageBtn" class="object-icon-newelem editPage"
        *ngIf="currentWebPage != undefined && currentWebPage != ''" (click)="openEditWebPageModal(currentWebPage)">
        <span uk-tooltip="Edit Page" class="pencil-icon" uk-icon="pencil"></span>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="element-object-container row" [hidden]="currentWebPage == undefined || currentWebPage == ''">
      <div class="col-sm-2" *ngFor="let wot of webobjecttype" (click)="filterByWebObjectType(wot.name)">
        <div class="element-box row " matTooltip="{{wot.name}}"
          [ngClass]="{'selected':currentWebObjectType == wot.name}">
          <span class="element-icon col-sm-4">
            <span class="material-icons">{{wot.icon}}</span>
          </span>
          <span class="element-text col-sm-8 ellipsis">
            {{wot.name}}
          </span>
        </div>
      </div>
    </div>
    <div class="element-list-container row">
      <div class="col-sm-12">
        <div class="object-List-Box row">
          <h3 *ngIf="currentWebPage == undefined || currentWebPage == ''" class="no-step-selected"> Create / Select
            Webpage To View Web Objects </h3>
          <div [hidden]="currentWebPage == undefined || currentWebPage == ''|| element?.hidden" class="col-sm-2"
            *ngFor="let element of targetobjectsFiltered">
            <div class="element row" id="FullElement" [ngClass]="{'highlighted': highlightedIds.includes(element._id)}">
              <span class="object-icon col-sm-3 no-border" (click)="editElement(element)">
                <span class="material-icons ">{{getIconFromWebObjectType(element?.webobjectType)}}</span>
              </span>
              <span class="element-obj-text col-sm-7" (click)="editElement(element)" matTooltip="{{element.name}}">
                {{element.name}}
              </span>
              <span class="floating-trash col-sm-2">

                <!-- API object: apply API_TESTING feature access -->
                <ng-container *ngIf="element.type === 'API'; else normalObjectActions">

                  <mat-icon (click)="deleteWebObject(element._id, element.type)" style="font-size: 1.4em;"
                    [featureActionState]="'API_TESTING'">
                    delete
                  </mat-icon>

                  <mat-icon (click)="copyObject(element)" style="font-size: 1.4em;"
                    [featureActionState]="'API_TESTING'">
                    content_copy
                  </mat-icon>

                </ng-container>

                <!-- Non-API object: no feature restriction -->
                <ng-template #normalObjectActions>

                  <mat-icon (click)="deleteWebObject(element._id, element.type)" style="font-size: 1.4em;">
                    delete
                  </mat-icon>

                  <mat-icon (click)="copyObject(element)" style="font-size: 1.4em;">
                    content_copy
                  </mat-icon>

                </ng-template>

              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="adminActions" id="addElementButton" (click)="addNewElement()"
  *ngIf="currentWebPage != undefined && currentWebPage != ''" matTooltip="Add Element">
  <input type="checkbox" name="adminToggle" class="adminToggle" />
  <a class="adminButton">
    <span uk-tooltip="Add new" class="add-icon" uk-icon="plus"></span>
  </a>
</div>`
<div id="repository" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
      </div>
      <div class="modal-body">
        <p>Some text in the modal.</p>
      </div>
    </div>
  </div>
</div>
<div id="deleteConfirmation" class="modal fade bd-example-modal-sm" tabindex="-1" role="dialog"
  aria-labelledby="deleteConfirmation" aria-hidden="true">
  <div class="modal-dialog modal-sm delete-modal">
    <div class="modal-content confirm-delete">
      <div class="row">
        <span class="col-sm-12 header">Are you sure you want to delete this element ?</span>
        <div class="col-sm-12"></div>
        <span class="col-sm-6"><button type="button" class="btn btn-primary blu-delete-confirm-btn"
            (click)="deleteConfirm()">Yes</button></span>
        <span class="col-sm-6"><button type="button" class="btn btn-secondary blu-delete-reject-btn"
            data-dismiss="modal">Cancel</button></span>
      </div>
    </div>
  </div>
</div>
<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="newPage" aria-labelledby="newPage"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-header">
      <h5 class="modal-title">
        Create New Page
      </h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-content">
      <div class="row detailer">
        <form>
          <span class="form__field">
            <input id="page__name" type="text" name="PageName" [(ngModel)]="newWP.name" matTooltipPosition="right"
              matTooltip="Page Name" class="form__input" placeholder="Page Name">
          </span>
          <span class="form__field">
            <input id="page__url" type="text" name="URL" [(ngModel)]="newWP.url" matTooltipPosition="right"
              matTooltip="URL" class="form__input" placeholder="URL">
          </span>
          <span class="form__field">
            <input id="page__description" type="text" name="Description" [(ngModel)]="newWP.description"
              matTooltipPosition="right" matTooltip="Description" class="form__input" placeholder="Description">
          </span>
        </form>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="addNewPage('deleted')">Delete Webpage</button>
      <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      <button type="button" class="btn btn-primary" (click)="addNewPage('new')">Save changes</button>
    </div>
  </div>
</div>